module.exports = __webpack_public_path__ + "media/application/images/svgs/instagram-dark-1bc0edaae2f21e7424b3ab5d36af898d.svg";